import React from 'react';
import { Tooltip } from '../../../../../../../ui-toolkit';
import { ISigningAppointmentDocumentResponse } from '../../../../../../../types/signingAppointment/ISigningAppointmentDocumentResponse';
import { isSent } from '../Utils';
import { toLocalTimeZone } from '../../../../../../../utilities/timeHelpers';

export const OutgoingTooltip: React.FC<{
  document: ISigningAppointmentDocumentResponse;
  children: React.ReactNode;
}> = ({ children, document }) => {
  if (!isSent(document)) return <>{children}</>;

  return (
    <Tooltip
      tooltipContent={
        <div className={'max-w-72'}>
          <OutgoingAndSentContent document={document} />
        </div>
      }
      trigger={'hover'}
      placement={'top'}
    >
      {children}
    </Tooltip>
  );
};

const OutgoingAndSentContent: React.FC<{ document: ISigningAppointmentDocumentResponse }> = ({ document }) => {
  if (!!document?.markedForDeletionAt) {
    return <>{`${toLocalTimeZone(document.markedForDeletionAt, true, true)}`}</>;
  }

  return (
    <>
      <p>{`Sent by ${document.sentBy?.fullName}`}</p>
      <p>{`${toLocalTimeZone(document.sentAt!, true, true)}`}</p>
    </>
  );
};
